import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { AddressListing, AddressSummary } from '~/models/modules/address';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class AddressesService extends ApiServiceBase {
  addressClosed: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  AddressAdded: EventEmitter<any> = new EventEmitter();
  AddressUpdated: EventEmitter<any> = new EventEmitter();
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  getAddress(id: number) {
    return this.http.get<AddressSummary>(this._url(`/${id}`));
  }

  getAddressesSummary() {
    return this.http.get<AddressSummary[]>(this._url(`/addressessummary`));
  }

  getAddressesListing() {
    return this.http.get<AddressListing[]>(this._url());
  }

  getAddressesSiteBuildingSummary(model: any = null) {
    if (!model)
      model = {};
    return this.http.post<AddressSummary[]>(this._url(`/addressesAndSite-summary`), model);
  }
  getAddressesByAccounts(model: any) {
    return this.http.post<AddressSummary[]>(this._url(`/AddressesByAccounts`), model);
  }

  getAddresses(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<AddressSummary[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  getAccountsAddresses(accountIds: any[], paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    model['accountIds'] = accountIds;

    return this.http
      .post<AddressSummary[]>(this._url(`/accounts`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  createAddress(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updateAddress(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  deleteAddress(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }
  deactivateAddress(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }
  deactivateAddressBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }
  reactivateAddress(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }

  reactivateAddressBatch(obj: any) {
    return this.client.put(this._url(`/reactivate-batch`), obj);
  }

  getQtyItemInAddressByDate(id: number) {
    return this.client.get(this._url(`/Number-of-item-in-address/${id}`));
  }

  getQtyLocationsInAddressByDate(id: number) {
    return this.client.get(this._url(`/Number-of-locations-in-address/${id}`));
  }


  GetStockItemByAddressChart(addressId: number) {
    return this.client.get(this._url(`/Addresses/${addressId}/StockItemAddressChart`));
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Addresses${v}`);
  }

  addressFormClosed(newValue: any) {
    this.addressClosed.next(newValue);
  }
}
